import {
  Container,
  Excerpt,
  Heading,
  IllustrationInnerWrapper,
  IllustrationOuterWrapper,
  Text,
} from "./styles";
import IllustrationComponent from "./Illustration";
import React from "react";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Illustration = IllustrationComponent as any;

export type HighlightProps = {
  heading?: string;
  excerpt?: string;
  image?: {
    asset?: {
      url?: string;
    };
    alt?: string;
    position?: string;
  };
  textPosition?: "right" | "left";
};

const Highlight: React.FC<HighlightProps> = (props) => {
  const { heading, excerpt, image, textPosition } = props;
  return (
    <Container textPosition={textPosition}>
      {(heading || excerpt) && (
        <Text>
          {heading && <Heading as="h2">{heading}</Heading>}
          {excerpt && <Excerpt>{excerpt}</Excerpt>}
        </Text>
      )}
      {image && (
        <IllustrationOuterWrapper>
          <IllustrationInnerWrapper>
            <Illustration image={image} />
          </IllustrationInnerWrapper>
        </IllustrationOuterWrapper>
      )}
    </Container>
  );
};

export default Highlight;
